import { render, staticRenderFns } from "./InsightCategoryDeleteForm.vue?vue&type=template&id=5aad7e51&scoped=true"
import script from "./InsightCategoryDeleteForm.vue?vue&type=script&lang=js"
export * from "./InsightCategoryDeleteForm.vue?vue&type=script&lang=js"
import style0 from "./InsightCategoryDeleteForm.vue?vue&type=style&index=0&id=5aad7e51&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aad7e51",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5aad7e51')) {
      api.createRecord('5aad7e51', component.options)
    } else {
      api.reload('5aad7e51', component.options)
    }
    module.hot.accept("./InsightCategoryDeleteForm.vue?vue&type=template&id=5aad7e51&scoped=true", function () {
      api.rerender('5aad7e51', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/InsightCategory/InsightCategoryDeleteForm.vue"
export default component.exports